import { addBreadcrumb } from "../config/sentry";

const PERF_PREFIX = "ac"; // alphacore

/**
 * Start a performance mark for a named flow.
 */
export function markStart(flow: string): void {
  performance.mark(`${PERF_PREFIX}:${flow}:start`);
}

/**
 * End a performance mark and measure the duration.
 * Returns the duration in ms, or null if start mark was missing.
 */
export function markEnd(flow: string): number | null {
  const startName = `${PERF_PREFIX}:${flow}:start`;
  const endName = `${PERF_PREFIX}:${flow}:end`;

  // Bail if no start mark exists
  if (!performance.getEntriesByName(startName, "mark").length) {
    return null;
  }

  performance.mark(endName);

  try {
    const measure = performance.measure(
      `${PERF_PREFIX}:${flow}`,
      startName,
      endName,
    );

    // Report to Sentry as breadcrumb for correlation
    addBreadcrumb({
      category: "performance",
      message: flow,
      level: "info",
      data: { duration_ms: Math.round(measure.duration) },
    });

    // Cleanup
    performance.clearMarks(startName);
    performance.clearMarks(endName);
    performance.clearMeasures(`${PERF_PREFIX}:${flow}`);

    return measure.duration;
  } catch {
    return null;
  }
}

/** Pre-defined flow names for consistency */
export const FLOWS = {
  LOGIN: "login",
  CASE_LIST_LOAD: "case-list.load",
  CASE_DETAIL_LOAD: "case-detail.load",
  CASE_CREATE: "case.create",
  DOCUMENT_UPLOAD: "document.upload",
} as const;
